export const THEME_KEY = "theme-mode";

export function getTimeBasedTheme(date = new Date()) {
  const hour = date.getHours();
  return hour >= 7 && hour < 19 ? "light" : "dark";
}

export function resolveTheme(mode, date = new Date()) {
  if (mode === "light" || mode === "dark") return mode;
  return getTimeBasedTheme(date);
}

export function applyTheme(mode, date = new Date()) {
  const theme = resolveTheme(mode, date);
  document.documentElement.dataset.theme = theme;
  document.documentElement.classList.toggle("dark", theme === "dark");
  document.documentElement.classList.toggle("light", theme === "light");
  return theme;
}
